import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';

export const FuelConsumptionReport = new Module({
  id: 'fuel-consumption-report',
  name: 'Fuel Consumption Report',
  path: 'fuel-consumption',
  Component: ComponentLoader(
    lazy(() => import('src/content/reports/FuelConsumption'))
  )
});
